var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSocketsWall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,6.17A25.83,25.83,0,1,1,6.17,32,25.86,25.86,0,0,1,32,6.17m0-4A29.83,29.83,0,1,0,61.83,32,29.84,29.84,0,0,0,32,2.17Z",
    fill: "#4f4e4f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.58,20.33v6H41v-6h2.55m1-1H40v8h4.55v-8Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.39,18.41V30H21.51V25.94H16V22.5h5.47V18.41h3.88m1-1H20.51V21.5H15v5.44h5.47V31h5.88V17.41Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.07,41.81a2.39,2.39,0,0,1,2.4,2.39v7.87H28.55V44.2a2.39,2.39,0,0,1,2.39-2.39h1.13m0-1H30.94a3.39,3.39,0,0,0-3.39,3.39v8.87h7.92V44.2a3.4,3.4,0,0,0-3.4-3.39Z",
    fill: "#4f4e4f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSocketsWall);
export default __webpack_public_path__ + "static/media/img_sockets_Wall.6b49608ff1f4aa8b8d23664ff7d470d5.svg";
export { ForwardRef as ReactComponent };